module.exports = {
  USER_KEY: '@clube-User',
  TOKEN_KEY: '@clube-Token',
  LIST_USERS_KEY: '@clube-ListUsers',
  FORM_OBJECT: {
    address: '',
    birthContact: '',
    city: '',
    cnpj: '',
    contactEmail: '',
    complement: '',
    corporateName: '',
    CPFContact: '',
    description: '',
    discountAmount: '',
    fantasyName: '',
    fullNameContact: '',
    facebook: '',
    hasCourtesy: false,
    hasDelivery: false,
    instagram: '',
    isUnity: true,
    latitude: '',
    longitude: '',
    logo: '',
    neighborhood: '',
    number: '',
    discountType: 1,
    whiteLabelId: null,
    startDateWhiteLabel: null,
    endDateWhiteLabel: null,
    partnerUnitAmenities: [],
    partnerUnitImagens: [],
    partnerUnityOpeningHours: [
      {
        id: 0,
        day: 'Segunda-Feira',
        date: '2019-11-18',
        isValid: false,
        open: new Date('2019-01-01T09:00:00'),
        close: new Date('2019-01-01T18:00:00')
      },
      {
        id: 1,
        day: 'Terça-Feira',
        date: '2019-11-19',
        isValid: false,
        open: new Date('2019-01-01T09:00:00'),
        close: new Date('2019-01-01T18:00:00')
      },
      {
        id: 2,
        day: 'Quarta-Feira',
        date: '2019-11-20',
        isValid: false,
        open: new Date('2019-01-01T09:00:00'),
        close: new Date('2019-01-01T18:00:00')
      },
      {
        id: 3,
        day: 'Quinta-Feira',
        date: '2019-11-21',
        isValid: false,
        open: new Date('2019-01-01T09:00:00'),
        close: new Date('2019-01-01T18:00:00')
      },
      {
        id: 4,
        day: 'Sexta-Feira',
        date: '2019-11-22',
        isValid: false,
        open: new Date('2019-01-01T09:00:00'),
        close: new Date('2019-01-01T18:00:00')
      },
      {
        id: 5,
        day: 'Sábado',
        date: '2019-11-23',
        isValid: false,
        open: new Date('2019-01-01T09:00:00'),
        close: new Date('2019-01-01T18:00:00')
      },
      {
        id: 6,
        day: 'Domingo',
        date: '2019-11-24',
        isValid: false,
        open: new Date('2019-01-01T09:00:00'),
        close: new Date('2019-01-01T18:00:00')
      }
    ],
    partnerTags: [],
    PartnerVipRoles: 1,
    phoneNumberContact: '',
    printedOnCourtesy: true,
    responsibleUser: '',
    partnerCitysMoviesId: null,
    roles: '',
    seoDescription: '',
    site: '',
    slug: '',
    uf: '',
    unityEmail: '',
    unityCompanyEmail: null,
    userCompanyEmail: '',
    whatsapp: '',
    zipcode: '',
    amountOfCourtesies: '',
    cover: '',
    eventsTags: [],
    eventsPricing: [],
    eventsProgramming: [],
    name: '',
    place: 0,
    producer: 0,
    rating: 0,
    partnerVipRoles: '',
    partnerType: 1,
    placeName: '',
    hasPurchaseInClub: false,
    herosparkAccess: true,
    reward: ''
  },
  TEXTAREA_BUTTONS: [
    'source',
    '|',
    'bold',
    'strikethrough',
    'underline',
    'italic',
    '|',
    'superscript',
    'subscript',
    '|',
    'ul',
    'ol',
    '|',
    'outdent',
    'indent',
    '|',
    'font',
    'fontsize',
    'brush',
    'paragraph',
    '|',
    'align',
    'undo',
    'redo',
    '\n',
    'selectall',
    'cut',
    'copy',
    'paste',
    'eraser',
    'copyformat',
    '|',
    'hr',
    'symbol',
    'fullsize'
  ],
  OBLIGATED_FIELDS: [
    {
      key: 'cnpj',
      showRed: false,
      message: 'O campo de CNPJ não pode ficar vazio'
    },
    {
      key: 'slug',
      showRed: false,
      message: 'O campo de Slug não pode ficar vazio'
    },
    {
      key: 'seoDescription',
      showRed: false,
      message: 'O campo Descrição SEO não pode ficar vazio'
    },
    // {
    //   key: 'email',
    //   showRed: false,
    //   message: 'O campo de Email não pode ficar vazio',
    // },
    // {
    //   key: 'name',
    //   showRed: false,
    //   message: 'O campo de Nome não pode ficar vazio',
    // },
    {
      key: 'roles',
      showRed: false,
      message: 'O campo de Informações sobre o Desconto não pode ficar vazio'
    },
    {
      key: 'fantasyName',
      showRed: false,
      message: 'O campo do Nome Fantasia não pode ficar vazio'
    },
    {
      key: 'corporateName',
      showRed: false,
      message: 'O campo da Razão Social não pode ficar vazio'
    },
    {
      key: 'userCompanyEmail',
      showRed: false,
      message: 'O campo de E-mail para a Dashboard não pode ficar vazio'
    },
    {
      key: 'contractRoles',
      showRed: false,
      message: 'O campo do Regulamento do Contrato não pode ficar vazio'
    },
    {
      key: 'purchaseInClubURL',
      showRed: false,
      message: 'O campo do Regulamento do Contrato não pode ficar vazio'
    }
  ],
  PUSH_TYPE_LIST: [
    { id: 1, name: 'Todos' },
    { id: 2, name: 'Assinante Único' },
    { id: 3, name: 'Tópico Específico' }
  ]
}
